import script from "./CompletedDonation.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletedDonation.vue?vue&type=script&setup=true&lang=js"

import "./CompletedDonation.vue?vue&type=style&index=0&id=1d318640&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d318640"]])

export default __exports__